/** @format */

import { HomrCta } from './content-types/cta.interface';

export interface HomrInStoreServices {
  cta: HomrCta[];
  ctaDropdown: string;
  headline: string;
  icon: string;
  panelTitle: string;
  pdpText: string;
  primaryPanelContent: string;
  secondaryPanelContent: string;
}
